<template>
  <div>
    <el-form ref="form" label-width="262px" :model="form" :rules="rules" label-position="left">
      <el-collapse v-model="activeNames" class="payment-link-collapse">
        <el-collapse-item :title="$t('payment_links.link_info')" name="1" :class="{'link-info-collapse':form.link_mode===LINK_MODE.basedOnProduct}">
          <!-- 链接信息 -->
          <el-form-item :label="$t('payment_links.link_icon')" prop="link_icon">
            <div class="avatar-wrapper">
              <img v-if="form.link_logo_oss_url" :src="form.link_logo_oss_url" class="img-avatar" @click="onClickEditLogo">
              <el-button v-if="!isDetails" @click="onClickEditLogo">{{ $t('payment_links.upload_photo') }}</el-button>
            </div>
            <AvatorUpload
              :model-value="showAvatorUpload"
              field="img"
              :lang-ext="langExt"
              :lang-type="$store.getters.language"
              no-square
              @update:modelValue="onChangeAvatorUpload"
              @crop-success="cropSuccess"
            />
          </el-form-item>

          <el-form-item :label="$t('payment_links.link_no')" prop="mch_ref_no">
            <span v-if="$route.query.type" class="content-text">{{ form.mch_ref_no }}</span>
            <el-input v-else v-model.trim="form.mch_ref_no" :disabled="isDetails" :placeholder="$t('payment_links.link_no')" class="from-input" size="small" type="text" clearable />
          </el-form-item>

          <el-form-item :label="$t('payment_links.link_title')" prop="title">
            <span v-if="isDetails" class="content-text">{{ form.title }}</span>
            <el-input v-else v-model="form.title" :disabled="isDetails" maxlength="50" :placeholder="$t('payment_links.link_title')" class="from-input" size="small" type="text" clearable />
          </el-form-item>

          <!--订单模式  -->
          <el-form-item :label="$t('payment_links.order_mode')" prop="link_mode" required>
            <span v-if="isDetails" class="content-text">{{ getLinkModeMapLabel(form.link_mode) }}</span>
            <el-radio-group v-else v-model="form.link_mode" :disabled="isDetails" @input="onChangeOrderMode">
              <el-radio :label="LINK_MODE.fixedAmount">{{ $t('payment_links.fixed_amount') }}</el-radio>
              <el-radio :label="LINK_MODE.basedOnProduct">{{ $t('payment_links.based_on_product') }}</el-radio>
              <el-radio :label="LINK_MODE.customerToEnter">{{ $t('payment_links.customer_to_enter') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 固定金额 -->
          <el-form-item v-if="form.link_mode===LINK_MODE.fixedAmount" :label="$t('payment_links.amount')" prop="amount">
            <span v-if="isDetails" class="content-text">{{ form.amount | numWithDot }}</span>
            <el-input v-else v-model="form.amount" type="text" class="from-input" :placeholder="$t('payment_links.amount')" autocomplete="off" clearable />
            <!-- <el-input-number
              v-else
              v-model="form.amount"
              class="from-input"
              size="small"
              :placeholder="$t('payment_links.amount')"
              autocomplete="on"
              :max="2000000"
              :min="0"
              clearable
              :controls="false"
              type="text"
              :precision="2"
            /> -->
          </el-form-item>

          <el-form-item :label="$t('payment_links.payment_description')" prop="description">
            <span v-if="isDetails" class="content-text">{{ form.description }}</span>
            <el-input v-else v-model="form.description" :disabled="isDetails" maxlength="256" :placeholder="$t('payment_links.payment_description')" class="from-input" autosize type="textarea" clearable />
          </el-form-item>

          <el-form-item :label="$t('payment_links.remark')" prop="remark">
            <span v-if="isDetails" class="content-text">{{ form.remark || '-' }}</span>
            <el-input v-else v-model="form.remark" :disabled="isDetails" maxlength="256" :placeholder="$t('payment_links.remark')" class="from-input" autosize type="textarea" clearable />
          </el-form-item>

          <!-- 基于产品 -->
          <el-form-item v-if="form.link_mode===LINK_MODE.basedOnProduct" :label="$t('payment_links.product')" prop="product">
            <el-select
              v-if="!isDetails"
              v-model="form.product"
              :disabled="isDetails"
              filterable
              :filter-method="filterMethod"
              :placeholder="$t('payment_links.add_product_or_search_on_list')"
              :popper-append-to-body="false"
              class="product-select"
              size="small"
              clearable
              @clear="clearProduct"
            >
              <div v-infinite-scroll="scrollProduct">
                <el-option value="" disabled>
                  <div class="add-new-product" @click="addProduct">
                    + {{ $t('payment_links.add_new_product') }}
                  </div>
                </el-option>

                <el-option
                  v-for="(item,index) in productList"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                >
                  <div class="product-item" @click.stop="selectProduct(item,index)">
                    <div class="product-info">
                      <span class="product-name">
                        {{ item.name }}
                      </span>
                      <span class="price">
                        {{ $store.getters.currency }} {{ item.price | toDivideWithDot }}
                      </span>
                    </div>
                    <div>
                      <svg-icon class-name="add-icon" icon-class="icon-edit" @click.stop="editProduct(item)" />
                      <svg-icon class-name="add-icon" icon-class="icon-delete" @click.stop="clickDeleteBtn(item.product_no)" />
                    </div>
                  </div>
                </el-option>
                <el-option v-if="productListAllSet.size===total || productList.length===0" value="" disabled>
                  <div class="no-data-item">
                    {{ $t('payment_links.no_more_data') }}
                  </div>
                </el-option>
              </div>
            </el-select>
          </el-form-item>
          <!-- 基于产品 -->
          <div class="tableContainer">
            <el-table v-if="form.link_mode===LINK_MODE.basedOnProduct" :data="selectedProductList" stripe fit style="width: 100%" max-height="500">
              <el-table-column :label="$t('payment_links.product_name')" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('payment_links.price')" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.price | toDivideWithDot }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('payment_links.quantity')" align="center">
                <template slot-scope="scope">
                  <span v-if="isDetails" class="content-text">{{ scope.row.quantity }}</span>
                  <el-input-number
                    v-else
                    v-model="scope.row.quantity"
                    size="mini"
                    :placeholder="$t('payment_links.quantity')"
                    autocomplete="on"
                    :max="99"
                    :min="scope.row.allow_adjust===1?0:1"
                    clearable
                    :controls="false"
                    type="text"
                    :precision="0"
                    @change="changeQuantity(scope.row,scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column :label="$t('payment_links.allow_adjust')" align="center">
                <template slot-scope="scope">
                  <span v-if="isDetails" class="content-text">{{ scope.row.allow_adjust===1? $t('components.yes') : $t('components.no') }}</span>
                  <el-checkbox v-else v-model="scope.row.allow_adjust" :true-label="1" :false-label="2" :disabled="isDetails" size="medium" class="checkbox" @change="changeAllowAdjust(scope.row,scope.$index)" />
                </template>
              </el-table-column>
              <el-table-column :label="$t('payment_links.image')" align="center">
                <template slot-scope="scope">
                  <img v-viewer :src="scope.row.pic" height="40px" style="cursor: pointer;">
                </template>
              </el-table-column>
              <el-table-column v-if="!isDetails" :label="$t('components.operation')" align="center">
                <template slot-scope="scope">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('components.delete') }}</span>
                    </div>
                    <svg-icon class-name="icon-function" icon-class="icon-delete" @click="onClickDeleteBtn(scope.row,scope.$index)" />
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>

        <el-collapse-item :title="$t('payment_links.customer_info')" name="2">
          <el-form-item :label="$t('payment_links.collect_customer_info')" prop="collect_mode" required>
            <span v-if="isDetails" class="content-text">{{ getCollectModeMapLabel(form.collect_mode) }}</span>
            <el-radio-group v-else v-model="form.collect_mode" :disabled="isDetails">
              <el-radio v-for="(item,index) in collectModeMap" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="form.collect_mode===COLLECT_MODE.no" :label="$t('payment_links.customer_name')" prop="customer_name">
            <span v-if="isDetails" class="content-text">{{ form.customer_name }}</span>
            <el-input v-else v-model="form.customer_name" :disabled="isDetails" maxlength="128" :placeholder="$t('payment_links.customer_name')" class="from-input" size="small" type="text" clearable />
          </el-form-item>

          <el-form-item v-if="form.collect_mode===COLLECT_MODE.no" :label="$t('payment_links.customer_email')" prop="email">
            <span v-if="isDetails" class="content-text">{{ form.email }}</span>
            <el-input v-else v-model.trim="form.email" :disabled="isDetails" :placeholder="$t('payment_links.customer_email')" class="from-input" size="small" type="text" clearable />
          </el-form-item>

          <el-form-item v-if="form.collect_mode===COLLECT_MODE.no" :label="$t('payment_links.customer_mobile')" prop="mobile">
            <span v-if="isDetails" class="content-text">{{ form.mobile }}</span>
            <el-input v-else v-model.trim="form.mobile" :disabled="isDetails" :placeholder="$t('payment_links.customer_mobile')" class="from-input" size="small" type="text" clearable />
          </el-form-item>
        </el-collapse-item>

        <!-- 其他信息 -->
        <el-collapse-item :title="$t('payment_links.other_info')" name="3">
          <div v-if="isEdit" class="customer-info-tips">{{ $t('payment_links.available_edits_left') }}:{{ modificationCount }}</div>
          <el-form-item :label="$t('payment_links.add_customer_field')" prop="field_type" required>
            <span v-if="isEdit&&!modificationCount || isDetails" class="content-text">{{ getAddCustomerFieldModeMapLabel(form.field_type) }}</span>
            <el-radio-group v-else v-model="form.field_type" @change="$forceUpdate()">
              <el-radio v-for="(item,index) in addCustomerFieldModeMap" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.field_type===ADD_CUSTOMER_FIELD.yes" class="customer-info">
            <div v-for="(item, index) in form.field_list" :key="index" class="customer-info-item">
              <div class="left">
                <div v-if="isEdit&&!modificationCount || isDetails" :key="index" class="content-text field-select-item">{{ getCustomerTypeMapLabel(item.type) }}</div>
                <el-select v-else :key="index" v-model="item.type" class="field-select-item" size="small" clearable>
                  <el-option :label="$t('payment_links.text')" :value="CUSTOMER_FIELD.text" />
                  <el-option :label="$t('payment_links.number_only')" :value="CUSTOMER_FIELD.numberOnly" />
                </el-select>
              </div>
              <div class="right">
                <div v-if="isEdit&&!modificationCount || isDetails" :key="index" class="content-text">{{ item.name }}</div>
                <el-input v-else v-model="item.name" maxlength="64" :placeholder="$t('payment_links.label_name')" class="field-label-item from-input" size="small" type="text" clearable />
                <el-button v-if="modificationCount&&!isDetails" v-show="form.field_list.length>1" class="delete-btn" @click="deleteCustomerField(index)">{{ $t('components.delete') }}</el-button>
                <br v-if="modificationCount&&!isDetails">
                <span v-if="isEdit&&!modificationCount || isDetails" class="content-text">{{ item.option_type===OPTION_TYPE.required? $t('payment_links.marked_as_required') : $t('payment_links.mark_as_optional') }}</span>
                <el-checkbox v-else v-model="item.option_type" :true-label="OPTION_TYPE.optional" :false-label="OPTION_TYPE.required" size="medium" class="checkbox">
                  {{ $t('payment_links.mark_as_optional') }}
                </el-checkbox>
                <div>
                  <el-button v-if="modificationCount&&!isDetails" v-show="index === form.field_list.length - 1" type="info" class="add-btn" @click="addCustomerField">{{ $t('payment_links.add_another_field') }}</el-button>
                </div>
              </div>
            </div>
          </div>

        </el-collapse-item>
        <el-collapse-item :title="$t('payment_links.payment_success_page')" name="2">
          <el-form-item :label="$t('payment_links.custom_message')" prop="custom_message">
            <span v-if="isDetails" class="content-text" style="word-break: break-word; white-space: pre-line;line-height: 1.5;">{{ form.custom_message || '-' }}</span>
            <el-input v-else v-model="form.custom_message" :disabled="isDetails" :maxlength="255" show-word-limit class="from-input" :rows="4" type="textarea" clearable />
          </el-form-item>
        </el-collapse-item>

        <el-collapse-item :title="$t('payment_links.link_configuration')" name="4">
          <el-form-item :label="$t('payment_links.link_type')" prop="link_type" required>
            <span v-if="isDetails" class="content-text">{{ getLinkTypeMapLabel(form.link_type) }}</span>
            <el-radio-group v-else v-model="form.link_type" :disabled="isDetails" @input="onChangeOrderTimes">
              <el-radio :label="LINK_TYPE.one" :disabled="form.link_mode===LINK_MODE.customerToEnter">{{ $t('payment_links.one_time') }}</el-radio>
              <el-radio :label="LINK_TYPE.more">{{ $t('payment_links.reusable') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="form.link_type===LINK_TYPE['more']" :label="$t('payment_links.max_of_payments_accepted')" prop="max_limit">
            <span v-if="isDetails" class="content-text">{{ form.max_limit || $t('payment_links.unlimited') }}</span>
            <el-input v-else v-model="form.max_limit" type="text" class="from-input" :placeholder="$t('payment_links.max_of_payments_accepted')" autocomplete="off" clearable />
            <!-- <el-input-number
              v-else
              v-model="form.max_limit"
              size="small"
              :placeholder="$t('payment_links.max_of_payments_accepted')"
              class="from-input"
              autocomplete="on"
              :max="999"
              :min="0"
              clearable
              :controls="false"
              type="text"
              :precision="0"
            /> -->
          </el-form-item>

          <el-form-item prop="expire_time">
            <template slot="label">
              {{ $t('payment_links.expiry_time') }}
            </template>
            <span v-if="isDetails" class="content-text">{{ form.expire_time || '-' }}</span>
            <el-date-picker
              v-else
              v-model="form.expire_time"
              type="datetime"
              class="from-input"
              :placeholder="$t('payment_links.expiry_time')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              align="right"
              clearable
              size="small"
              @focus="focus"
            />
          </el-form-item>
          <div class="time-zone-tips">{{ $t('payment_links.time_zone_tips') }}:UTC+8</div>
        </el-collapse-item>
      </el-collapse>

      <div class="dialog-footer">
        <el-button v-if="!isDetails" @click="goBack">{{ $t('components.cancel') }}</el-button>
        <el-button v-if="!isDetails" type="primary" :disabled="submitLoading" class="btn-submit" @click="onClickSubmitBtn('form')">{{
          $t('components.confirm')
        }}</el-button>
      </div>
    </el-form>
    <AddNewProudct ref="addNewProudct" @getProductList="getProductList" @clearProduct="clearProduct" />
    <CreateSuccessful ref="createSuccessful" />
  </div>
</template>

<script>

import { mchPageProduct, mchCreateLink, mchDetailLink, mchDeleteProduct, mchUpdateLink } from '@/api/payment-link/payment-link'
import { linkModeMap, linkTypeMap, collectModeMap, customerTypeMap, addCustomerFieldModeMap } from '@/utils/maps'
import { parseTime } from '@/utils/index.js'
import { uploadPublicImg } from '@/api/components/upload'
import AvatorUpload from 'vue-image-crop-upload'
export default {
  name: 'Payment_Link_Detail',
  components: {
    AddNewProudct: () => import('../Modal/AddNewProudct.vue'),
    CreateSuccessful: () => import('../Modal/CreateSuccessful.vue'),
    AvatorUpload
  },
  data() {
    this.langExt = {
      hint: 'Click or drag the file here to upload',
      loading: 'Uploading…',
      noSupported: 'Browser is not supported, please use IE10+ or other browsers',
      success: 'Upload success',
      fail: 'Upload failed',
      preview: 'Preview',
      btn: {
        off: 'Cancel',
        close: 'Close',
        back: 'Clear',
        save: 'Save'
      },
      error: {
        onlyImg: 'Image only',
        outOfSize: 'Image exceeds size limit: ',
        lowestPx: 'Image\'s size is too low. Expected at least: '
      }
    }
    const checkMchRefNoType = (rule, value, callback) => {
      if (!/^([a-zA-Z0-9]{1,32})$/g.test(value)) {
        return callback(new Error('Please enter the correct Reference Number'))
      }
      return callback()
    }
    const checkAmount = (rule, value, callback) => {
      value = Number(value)
      if (value <= 0 || isNaN(value)) {
        return callback(new Error('Please enter a non-negative number'))
      }
      if (value > 2000000) {
        return callback(new Error('Amount cannot be greater than 2000000'))
      }
      if (this.$store.getters.isVnMerchant) {
        // 越南只允许整数金额，无专门上下限
        if (!/^[1-9]\d*$/.test(String(value))) {
          return callback(new Error('Please enter a valid integer amount'))
        }
      }
      if (!/^(0|[1-9]\d*)(.\d{1,2})?$/.test(value)) {
        return callback(new Error('Please enter two decimal places'))
      }
      callback()
    }
    const checEmailType = (rule, value, callback) => {
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return callback(new Error('Please enter the correct Email'))
      }
      return callback()
    }
    const checkMobileType = (rule, value, callback) => {
      if (!/^09[0-9]{9,12}$/.test(value)) {
        return callback(new Error('Please enter the correct Mobile'))
      }
      return callback()
    }
    const checkPositiveIntegersType = (rule, value, callback) => {
      if (!value) {
        return callback()
      }
      if (value > 999) {
        return callback(new Error('Max Limit cannot be greater than 999'))
      }
      if (!/^[1-9]\d*$/.test(value)) {
        return callback(new Error('Only can input positive integers'))
      }
      return callback()
    }
    const checkExpireTime = (rule, value, callback) => {
      const time = new Date(value).getTime()
      // 获取菲律宾本地时间
      const loaclTime = this.getlocalTime(8).getTime()
      if (value && time <= loaclTime + 60 * 5 * 1000) {
        return callback(new Error('Please select a time after 5 minutes'))
      }
      return callback()
    }
    this.LINK_MODE = {
      fixedAmount: 1,
      basedOnProduct: 2,
      customerToEnter: 3
    }
    this.COLLECT_MODE = {
      yes: 1,
      no: 2
    }
    this.ADD_CUSTOMER_FIELD = {
      yes: 1,
      no: 2
    }
    this.CUSTOMER_FIELD = {
      text: 1,
      numberOnly: 2
    }
    this.OPTION_TYPE = {
      required: 1,
      optional: 2
    }
    this.LINK_TYPE = {
      one: 1,
      more: 2
    }
    return {
      sub_merchant_no: this.$route.params.sub_merchant_no,
      submitLoading: false,
      productListLoading: false, // 产品列表加载时禁止操作
      link_no: null, // 链接编号
      timer: null,
      total: 0,
      page: 1,
      modificationCount: 20,
      // isEdit: true,
      productList: [],
      productListSet: new Set(),
      filterList: [],
      productListAllSet: new Set(),
      selectedProductList: [],
      selectProductSet: new Set(),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      uploadLoading: false,
      showAvatorUpload: false,
      form: {
        link_logo_oss_url: this.$store.getters.userInfo.logo_img_oss_url,
        link_logo: this.$store.getters.userInfo.logo_img,
        link_mode: 1,
        collect_mode: 1,
        field_type: 2,
        link_type: 1,
        field_list: [
          {
            type: 1,
            name: '',
            option_type: 2
          }
        ],
        expire_time: parseTime(this.getlocalTime(8, Date.now() + 86400000))
      },
      rules: {
        mch_ref_no: [
          { required: true, message: 'Reference Number cannot be empty' },
          { validator: checkMchRefNoType, trigger: ['blur', 'change'] }
        ],
        title: [
          { required: true, message: 'Link Title cannot be empty' }
        ],
        amount: [
          { required: true, message: 'Amount cannot be empty' },
          { validator: checkAmount, trigger: ['blur', 'input', 'change'] }
        ],
        description: [
          { required: true, message: 'Description Name cannot be empty' }
        ],
        email: [
          { required: true, message: 'Email Name cannot be empty' },
          { validator: checEmailType, trigger: ['blur'] }
        ],
        customer_name: [
          { required: true, message: 'Customer Name cannot be empty' }
        ],
        mobile: [
          { required: true, message: 'Mobile cannot be empty' },
          { validator: checkMobileType, trigger: ['blur', 'change'] }
        ],
        max_limit: [
          // { required: true, message: 'Max of Pyaments Accepted cannot be empty' },
          { validator: checkPositiveIntegersType, trigger: ['blur', 'change'] }
        ],
        expire_time: [
          { validator: checkExpireTime, trigger: ['blur', 'change'] }
        ]
      },
      activeNames: ['1']
    }
  },
  computed: {
    isDetails() {
      return this.$route.query.type === 'detail'
    },
    isEdit() {
      return this.$route.query.type === 'edit'
    },
    getLinkModeMapLabel() {
      return (val) => linkModeMap(val).label
    },
    addCustomerFieldModeMap() {
      return addCustomerFieldModeMap()
    },
    getAddCustomerFieldModeMapLabel() {
      return (val) => addCustomerFieldModeMap(val).label
    },
    getLinkTypeMapLabel() {
      return (val) => linkTypeMap(val).label
    },
    collectModeMap() {
      return collectModeMap()
    },
    getCollectModeMapLabel() {
      return (val) => collectModeMap(val).label
    },
    getCustomerTypeMapLabel() {
      return (val) => customerTypeMap(val).label
    }
  },
  created() {
    this.link_no = this.$route.query.link_no
    if (this.link_no) {
      this.getDetails()
    } else {
      this.getProductList()
    }
  },
  methods: {
    getDetails() {
      mchDetailLink({
        sub_merchant_no: this.sub_merchant_no,
        link_no: this.link_no
      }).then(res => {
        this.form = res.data.payment_link
        this.modificationCount = res.data.modification_times
        const field_list = res.data.payment_link_field_list?.length > 0 ? res.data.payment_link_field_list : [{
          type: 1,
          name: '',
          option_type: 2
        }]
        this.form.link_logo_oss_url = res.data.link_logo_oss_url
        this.$set(this.form, 'field_list', field_list)
        this.form.field_type = res.data.payment_link_field_list?.length > 0 ? 1 : 2
        const amount = this.form.amount ? this.$commonFn.mathDivide(Number(this.form.amount), 100) : ''
        this.$set(this.form, 'amount', amount)
        this.$set(this.form, 'expire_time', res.data.expire_time || null)
        this.selectedProductList = res.data.payment_link_product_option_list || []
        this.selectedProductList.forEach(item => {
          this.selectProductSet.add(item.product_no)
        })
        this.getProductList()
        this.$emit('getInfo', res.data)
        if (this.form.collect_mode === this.COLLECT_MODE.no) {
          this.activeNames.push('2')
        }
        if (this.form.field_type === this.ADD_CUSTOMER_FIELD.yes) {
          this.activeNames.push('3')
        }
        if (this.form.link_type === this.LINK_TYPE.more || this.form.expire_time) {
          this.activeNames.push('4')
        }
      })
    },
    getProductList(params = { page: 1, size: 10 }, isInit) {
      this.productListLoading = true
      if (isInit) {
        this.productListAllSet.clear()
        this.productListSet.clear()
        this.productList = []
        this.page = 1
        this.total = 0
      }
      const productNum = this.productListSet.size
      params.sub_merchant_no = this.sub_merchant_no
      mchPageProduct(params).then(res => {
        this.page += 1
        this.total = res.data.total
        res.data.list.forEach(item => {
          this.productListAllSet.add(item.product_no)
          if (!this.selectProductSet.has(item.product_no)) {
            this.productListSet.add(item.product_no)
            this.productList.push(item)
          }
        })
        // 产品列表数量小于总数量,且当前产品列表数量小于5或当前产品列表数量未增加时继续请求
        if (this.productListAllSet.size < this.total && (this.productListSet.size === productNum || this.productListSet.size < 5)) {
          this.getProductList({ page: this.page, size: 10 })
        }
        this.productListLoading = false
      })
    },
    // 无限滚动
    scrollProduct() {
      if (!this.timer && this.productListAllSet.size < this.total && !this.form.product) {
        this.timer = setTimeout(() => {
          this.getProductList({ page: this.page, size: 10 })
          clearTimeout(this.timer)
          this.timer = null
        }, 500)
      }
    },
    clearProduct() {
      this.form.product = null
      this.getProductList({ page: 1, size: 10 }, true)
      this.$forceUpdate()
    },
    filterMethod(val) {
      if (!val) {
        this.form.product = null
        this.getProductList({ page: 1, size: 10 }, true)
        return
      }
      this.form.product = val // 先给绑定值赋值,否则会输入后值会消失
      mchPageProduct({ page: 1, size: 100, name: val, sub_merchant_no: this.sub_merchant_no }).then(res => {
        this.productListAllSet.clear()
        this.productListSet.clear()
        this.productList = []
        this.total = res.data.total
        res.data.list.forEach(item => {
          this.productListAllSet.add(item.product_no)
          if (!this.selectProductSet.has(item.product_no)) {
            this.productListSet.add(item.product_no)
            this.productList.push(item)
          }
        })
      })
    },
    selectProduct(item, index) {
      if (this.productListLoading) return
      item.quantity = 1
      this.selectedProductList.push(item)
      this.productList.splice(index, 1)
      this.selectProductSet.add(item.product_no)
      this.productListSet.delete(item.product_no)
      if (this.productListSet.size <= 5 && !this.form.product && this.productListAllSet.size < this.total) {
        this.getProductList({ page: this.page, size: 10 })
      }
      this.$forceUpdate()
    },
    onClickDeleteBtn(item, index) {
      if (this.productListLoading) return
      this.productListSet.add(item.product_no)
      this.selectProductSet.delete(item.product_no)
      this.productList.push(this.selectedProductList[index])
      this.selectedProductList.splice(index, 1)
    },
    addProduct() {
      if (this.productListLoading) return
      this.$refs.addNewProudct.changModalStatus(true)
    },
    editProduct(row) {
      if (this.productListLoading) return
      this.$refs.addNewProudct.changModalStatus(true, row)
    },
    clickDeleteBtn(product_no) {
      if (this.productListLoading) return
      this.$confirm(this.$t('payment_links.delete_product_tips'), this.$t('components.confirm'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        mchDeleteProduct({ product_no, sub_merchant_no: this.sub_merchant_no }).then(() => {
          this.clearProduct()
          this.form.product = null
          this.$message.success('Success')
        })
      })
    },
    // 清空产品数量时，若勾选了，则默认值为0，若未勾选，则默认值为1
    changeQuantity(row, index) {
      if (!row.quantity) {
        const quantity = row.allow_adjust === 1 ? '0' : '1'
        this.selectedProductList[index].quantity = +quantity
        this.$set(this.selectedProductList, index, { ...row, quantity })
      }
    },
    // 取消勾选时，若产品数量为0，则改为默认值1
    changeAllowAdjust(row, index) {
      if (row.allow_adjust !== 1 && !row.quantity) {
        this.selectedProductList[index].quantity = 1
        this.$set(this.selectedProductList, index, { ...row, quantity: '1' })
      }
    },
    onChangeOrderMode(val) {
      if (val === this.LINK_MODE.customerToEnter) {
        this.form.link_type = this.LINK_TYPE.more
        if (!this.activeNames.includes('4')) {
          this.activeNames.push('4')
        }
        this.form.expire_time = null
      } else {
        if (!this.activeNames.includes('4')) {
          this.form.link_type = this.LINK_TYPE.one
        }
        this.$set(this.form, 'expire_time', parseTime(this.getlocalTime(8, Date.now() + 86400000)))
      }
      // 切换订单模式后清除其他模式表单验证的错误信息
      this.$refs.form.clearValidate(['amount', 'description', 'remark', 'product'])
    },
    onChangeOrderTimes(val) {
      if (val === this.LINK_TYPE['more']) {
        this.form.expire_time = null
      } else {
        this.$set(this.form, 'expire_time', parseTime(this.getlocalTime(8, Date.now() + 86400000)))
      }
    },
    disabledDate(time) {
      return time.getTime() <= this.getlocalTime(8).getTime() - 8.64e7
    },
    focus() {
      this.$nextTick(() => {
        // 隐藏时间选择组件此刻的按钮
        document.getElementsByClassName('el-button--text')[0].setAttribute('style', 'display:none')
      })
    },
    deleteCustomerField(index) {
      this.form.field_list.splice(index, 1)
    },
    addCustomerField() {
      if (this.form.field_list.length >= 5) {
        this.$message.warning('Maximum of 5 fields can be added')
        return
      }
      this.form.field_list.push({
        type: 1,
        name: '',
        option_type: 2
      })
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { link_mode, amount, expire_time, collect_mode, customer_name, email, mobile, field_type, field_list, link_type, max_limit, ...otherSearch } = this.form
          const params = {
            sub_merchant_no: this.sub_merchant_no,
            link_mode,
            collect_mode,
            field_type,
            link_type,
            ...otherSearch
          }
          if (link_mode === this.LINK_MODE.fixedAmount) {
            params.amount = this.$commonFn.mathMultiply(Number(amount), 100)
          } else if (link_mode === this.LINK_MODE.basedOnProduct) {
            params.product_list = this.selectedProductList.map(item => {
              item.allow_adjust = item.allow_adjust || 2
              return item
            })
          }
          if (collect_mode === this.COLLECT_MODE.no) {
            params.customer_name = customer_name
            params.email = email
            params.mobile = mobile
          }
          if (expire_time) {
            params.expire_time = expire_time
          }
          if (field_type === this.ADD_CUSTOMER_FIELD.yes) {
            params.field_list = field_list
            let hasEmptyName = false
            const fieldListSet = new Set()
            field_list.forEach((item) => {
              if (!item.name || item.name.trim() === '') {
                hasEmptyName = true
              }
              fieldListSet.add(item.name)
            })
            if (hasEmptyName) {
              return this.$message.warning(this.$t('payment_links.field_empty_tips'))
            }
            if (fieldListSet.size < field_list.length) {
              return this.$message.warning(this.$t('payment_links.duplicate_label_name'))
            }
          }
          if (max_limit && link_type === this.LINK_TYPE.more) {
            params.max_limit = Number(max_limit)
          }
          const reqEvent = this.$route.query.type === 'edit' ? mchUpdateLink : mchCreateLink
          reqEvent(params).then(res => {
            if (res.code === 10000) {
              this.$refs.createSuccessful.changModalStatus(true, res.data)
            }
          })
        }
      })
    },
    // zone 表示时区，正数为东时区，负数为西时区
    getlocalTime(zone, time) {
      let d = new Date()
      if (time) {
        d = new Date(time)
      }
      // 获取本地时间
      const local_ms = d.getTime()
      // 本地时间与UTC时间的 时间偏移差(getTimezoneOffset的单位是min)
      const offset_ms = d.getTimezoneOffset() * 60 * 1000
      // 转为utc时间，因为各时区的utc时间相同
      const utc_ms = local_ms + offset_ms
      // 计算出 目标时区 的标准时间
      const target_ms = utc_ms + zone * 60 * 60 * 1000
      return new Date(target_ms)
    },
    onChangeAvatorUpload(value) {
      this.showAvatorUpload = value
    },
    onClickEditLogo() {
      if (this.isDetails) {
        return
      }
      this.showAvatorUpload = true
      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }
    },

    handleImageChange(file, avatarUrl) {
      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file)
      uploadPublicImg(formData).then(res => {
        if (res.code === 10000) {
          const path = res.data.path
          this.form.link_logo = path
          this.form.link_logo_oss_url = avatarUrl
        }
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    cropSuccess(avatarUrl, field) {
      const bstr = this.base64toFile(avatarUrl)
      this.handleImageChange(bstr, avatarUrl)
    },
    base64toFile(dataurl, filename = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    goBack() {
      this.$router.push({ name: 'Sub_Merchant_Content', params: { sub_merchant_no: this.$route.params.sub_merchant_no }, query: { page: this.$route.query.page, limit: this.$route.query.limit, activeName: 'PaymentLink' }})
    }
  }
}
</script>

<style lang="scss" scoped>
  .img-avatar{
    display: inline-block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 12px;
  }
  .no-img-avatar{
    display: inline-block;
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 26px;
    border-radius: 50%;
    text-align: center;
    border: 1px dashed #c0ccda;
    color: #D3D7DF;
    cursor: pointer;
  }
  .tip{
    margin-left: 16px;
    vertical-align: middle;
    width: 270px;
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #98A1B4;
  }
.payment-link-collapse{
  border: none;
  ::v-deep .el-collapse-item__header{
    color:#1D3A71;
    font-weight: 700;
    font-size: 16px;
    border: none;
    width: max-content;
    .el-collapse-item__arrow{
      margin: 0 0 0 10px!important;
      font-weight: 700;
    }
  }
  ::v-deep .el-collapse-item__wrap{
    border: none;
    .el-collapse-item__content{
      padding: 0;
    }
  }
  .link-info-collapse ::v-deep .el-collapse-item__wrap{
    overflow: visible;
  }
}
.from-input{
  width: 240px;
  ::v-deep .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-form-item__label{
  color: #1D3A71;
  font-weight: 500;
}
.product-select{
  width: 408px;
}
::v-deep .el-select-dropdown__item{
  height: 52px;
  &:has(.add-new-product){
    height: 40px;
    text-align: center;
    color: #1B4AEF;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10);
    cursor: pointer;
  }
  .product-item{
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .product-info{
      position: relative;
      height: 52px;
      font-weight: 700;
      .product-name{
        display: inline-block;
        width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .price{
        position: absolute;
        left: 0;
        bottom: -4px;
        font-size: 12px;
        color: rgba(24, 24, 24, 0.50);
        font-weight: normal;
      }
    }
  }
  &:has(.no-data-item){
    height: 32px;
  }
  .no-data-item{
    cursor: default;
    text-align: center;
    height: 32px;
    line-height: 32px;
  }
}
.customer-info-item{
  display: flex;
  // align-items: start;
  // flex-wrap: wrap;
  // justify-content: start;
  .left{
    width: 250px;
    margin-right: 12px;
  }
  .right{
    flex: 1;
  }
}
.add-icon{
  width: 16px;
  height: 16px;
  margin-left: 10px;
}
.field-select-item{
  width: 250px;
  margin-bottom: 48px;
}
.field-label-item{
  margin-bottom: 12px;
}
.delete-btn{
  margin-left: 12px;
  font-size: 12px;
}
.add-btn{
  margin-top: 12px;
  font-size: 12px;
}
.dialog-footer{
  padding-top: 14px;
}
.time-zone-tips{
  padding-left: 262px;
  font-size: 12px;
  color: #666;
}
.content-text{
  color: #1D3A71;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
}
.customer-info-tips{
  font-size: 12px;
  color: #666;
}
</style>
